import React, { useState, useEffect } from 'react'

import {
  Panel,
  Row,
  Col,
  ControlLabel,
  Input,
  Form,
  Message,
  InputNumber,
  IconButton,
  Icon,
  SelectPicker,
  Cascader,
} from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { isValidators, requiredFiled, isRequired } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import TransferList from '../../components/transferList/TransferList'
import ButtonPanelWidget from '../ButtonPanelWidget'

export default function RoleWidget(props) {
  const { isDeleteError, isError, loading, hideHeader, isEdit } = props
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [schema, setSchema] = useState(props.schema)
  const [section, setSection] = useState()

  useEffect(() => {}, [])

  const onSubmit = (data) => {
    console.log('data', data)
  }

  console.log('7777 ', schema)

  return (
    <>
      <Panel
        shaded
        header={schema.header}
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        <TransferList
          schema={schema}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
        />

        <br />
        <hr />

        <ButtonPanelWidget
          isEdit={isEdit}
          isError={isError}
          buttonText={schema.buttonText}
          onSave={handleSubmit(onSubmit)}
          onCancel={(el) => {
            console.log('8520', el)
            setIsError(false)
            handleCancel()
          }}
        />
      </Panel>
    </>
  )
}
